import { AnyAction } from 'redux';
import { SagaIterator } from 'redux-saga';
import { call, put, takeLatest } from 'redux-saga/effects';
import {
    FAILURE_REPAIR_ORDERS,
    FETCH_REPAIR_ORDERS,
    requestFinishRepairOrderSuccess,
    requestRepairOrders,
    requestRepairOrdersFailure,
    requestRepairOrdersSuccess,
    SUBMIT_FINISH_REPAIR_ORDER,
} from './actions';

import { APIError } from 'src/api';
import { fetchRepairOrders, finishRepairOrder } from 'src/api/repairOrders';
import { enqueueSnackbarAction } from '../notifications/actions';

function* fetchRepairOrderSaga(action: AnyAction): SagaIterator {
    yield put(requestRepairOrders());

    const { error, response } = yield call(fetchRepairOrders);

    if (error) {
        yield put(
            enqueueSnackbarAction({
                message: 'Fehler: Reparaturaufträge konnten nicht geladen werden!\n' + error.message,
                options: {
                    key: new Date().getTime() + Math.random(),
                    variant: 'error',
                },
            })
        );
        yield put(requestRepairOrdersFailure(error));
    } else {
        // yield put(
        //     enqueueSnackbarAction({
        //         message: response.statusText || 'Reparaturaufträge erfolgreich geladen',
        //         options: {
        //             key: new Date().getTime() + Math.random(),
        //             variant: 'success',
        //         },
        //     })
        // );
        yield put(requestRepairOrdersSuccess(response));
    }
}

function* submitFinishRepairOrderSaga(action: AnyAction): SagaIterator {
    yield put(requestRepairOrders());

    const { error, response } = yield call(finishRepairOrder, action.claimId, action.data);

    if (error) {
        yield put(requestRepairOrdersFailure(error));
    } else {
        yield put(
            enqueueSnackbarAction({
                message: 'Reparaturauftrag erfolgreich erledigt!',
                options: {
                    key: new Date().getTime() + Math.random(),
                    variant: 'success',
                },
            })
        );
    }
}

function* repairOrderFailureSaga(action: AnyAction): SagaIterator {
    const apiError = action.error as APIError;
    yield put(
        enqueueSnackbarAction({
            message: apiError.axios.response?.data?.message ?? apiError.message ?? apiError.code,
            options: {
                key: new Date().getTime() + Math.random(),
                variant: 'error',
            },
        })
    );
}

export function* generateFetchRepairOrder() {
    yield takeLatest(FETCH_REPAIR_ORDERS, fetchRepairOrderSaga);
}

export function* generateFinishRepairOrder() {
    yield takeLatest(SUBMIT_FINISH_REPAIR_ORDER, submitFinishRepairOrderSaga);
}

export function* generateRepairOrderFailure() {
    yield takeLatest(FAILURE_REPAIR_ORDERS, repairOrderFailureSaga);
}
